module.exports = __webpack_public_path__ + "static/media/visualize.81fd0803.png";